// extracted by mini-css-extract-plugin
export default {"cSBackground":"SoftwareDev_cSBackground__HLM+S","cSInto":"SoftwareDev_cSInto__ivB3b","cSText":"SoftwareDev_cSText__9UV0y"};